import { useEffect } from "react";
import { STORAGE_KEYS } from "../config";
import { ref, update } from "firebase/database";
import { db } from "../utils/firebase";
import { getUnixTime } from "date-fns";

export default function useSaveToken(
  companyId: string,
  id: string,
  token: string
) {
  useEffect(() => {
    async function saveToDatabase() {
      const updates: any = {};
      console.log(`'/fcmTokens/${companyId}-client/${id}`);
      updates["/fcmTokens/" + companyId + "-client/" + id] = {
        token,
        date: getUnixTime(new Date()),
      };

      await update(ref(db), updates);
    }

    if (companyId && id && token) {
      console.log("[useSaveToken]", { companyId, id, token });
      window.localStorage.setItem(STORAGE_KEYS.FCM_TOKEN, token);

      saveToDatabase().then(() => {
        console.log("**************** saved/updated token ****************");
      });
    }
  }, [companyId, id, token]);
}
